import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const RequireAuth = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  console.log("🔐 RequireAuth check:", {
    loading,
    hasUser: !!user,
    userRole: user?.role,
    requiredRole,
    pathname: location.pathname,
  });

  // Show loading state while authentication is being verified
  if (loading) {
    console.log("⏳ RequireAuth: Still loading authentication...");
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "18px",
          color: "#666",
        }}
      >
        <div>
          <div>Verifying authentication...</div>
          <div style={{ fontSize: "14px", marginTop: "8px", opacity: 0.7 }}>
            Please wait while we confirm your access
          </div>
        </div>
      </div>
    );
  }

  // Only redirect if we're certain user is not authenticated
  if (!user) {
    console.log("❌ RequireAuth: No user found, redirecting to login");
    window.location.href = "https://app.nestpedia.info/login";
    return null;
  }

  // Check role requirements with BULLETPROOF safety
  if (requiredRole !== undefined && requiredRole !== null) {
    try {
      // Ensure we have a valid array
      let allowedRoles = [];

      if (Array.isArray(requiredRole)) {
        allowedRoles = requiredRole.filter(
          (r) => r !== undefined && r !== null,
        );
      } else if (typeof requiredRole === "string") {
        allowedRoles = [requiredRole];
      } else {
        console.error(
          "❌ RequireAuth: Invalid requiredRole type:",
          typeof requiredRole,
          requiredRole,
        );
        return <Navigate to="/unauthorized" replace />;
      }

      // Check if user has role
      if (!user?.role) {
        console.log("❌ RequireAuth: User has no role");
        return <Navigate to="/unauthorized" replace />;
      }

      // Safe includes check
      const hasRole = allowedRoles.some((role) => role === user.role);

      if (!hasRole) {
        console.log("❌ RequireAuth: Role check failed", {
          userRole: user.role,
          allowedRoles,
          requiredRoleType: typeof requiredRole,
        });
        return <Navigate to="/unauthorized" replace />;
      }
    } catch (error) {
      console.error("❌ RequireAuth: Role check error:", error);
      return <Navigate to="/unauthorized" replace />;
    }
  }

  console.log("✅ RequireAuth: Access granted");
  return children;
};

// Component for checking multiple permissions;
export const RequirePermission = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "18px",
          color: "#666",
        }}
      >
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default RequireAuth;
